<template>
  <div class="p_chat_content">
    <!-- <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div> -->
    <div class="chat_title_box">
      <div class="flex">
        <div class="one_img_box">
          <img src="./../../assets/images/999.png" alt="">
        </div>
        <p class="txt03">小杰（AI服务官）</p>
      </div>
      <div class="chat_title_right">
        <div class="chat_title_icon">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="chat_txt">
          <p class="txt01">{{loginName}}</p>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="p_chat_box">
        <!-- 新建对话/切换模式模块 -->
        <div class="chat_btn_box">
          <div class="btn01" @click="newChat" v-show="isTxtMode">新建对话</div>
          <div :class="sendQuery.chatTaye == '1'?'btn02':'btn02 btn03'">
            <p class="txt02" v-if="sendQuery.chatTaye == '1'">剩余对话次数：{{residueNum}}次</p>
            <el-button type="success" size="mini" plain @click="transHandle">{{isTxtMode?'切换数字人模式':'切换文本模式'}}</el-button>
          </div>
        </div>
        <!-- 主要对话内容模块 -->
        <div class="chat_content" :class="{'isVoice':!isTxtMode}">
          <div class="chat_history" v-if="isTxtMode">
            <el-input clearable placeholder="搜索历史对话" @keyup.enter.native="getTitleList" prefix-icon="el-icon-search" v-model="titleQuery.titelname">
            </el-input>
            <div class="h_list">
              <div style="padding: 0 10px;">
                <div class="h_list_li cp" v-for="(item,index) in titleData" :key="index+'a'" v-if="item.Title" @click="searchHandle(item,index)">
                  <span :title="item.Title" :class="item.isSelected?'curr':''">{{item.Title}}</span>
                  <i class="el-icon-delete h_dlt_icon" @click.stop="dltChat(item)"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="chat_right_content">
            <div class="chat_main_box">
              <!-- 文本模式 -->
              <!-- 默认数字人模块 -->
              <div class="chat_robot_box" v-if="isTxtMode&&(isNull(chatQuery.Id))">
                <div class="one_img_box">
                  <img src="./../../assets/images/999.png" alt="">
                </div>
                <div class="robot_txt">
                  <p class="txt01" ref="chatMessages">
                    <span v-for="(char, i) in defaultMessages" :key="i+'D'">{{char}}</span>
                  </p>
                </div>
              </div>
              <div v-if="isTxtMode" class="chat_main_box00">
                <div class="chat_main_list" v-for="(item,index) in chatData" :key="index">
                  <!-- 自己发送模块 -->
                  <div class="chat_self_box" v-if="!isNull(item.ContentStr)">
                    <p class="chat_self_txt">{{item.ContentStr}}</p>
                    <div class="chat_self_icon">
                      <!-- el-icon-user -->
                      <i class="el-icon-user-solid"></i>
                    </div>
                  </div>
                  <!-- 数字人回答模块 -->
                  <div class="chat_robot_box">
                    <div class="one_img_box">
                      <!-- <img src="./../../assets/images/psn.png" alt=""> -->
                      <img src="./../../assets/images/999.png" alt="">
                    </div>
                    <div class="robot_txt">
                      <div class="loading" v-if="isSendFinish && index == chatData.length-1">
                        <i class="el-icon-loading" style="font-size: 18px;"></i>
                        生成中
                      </div>
                      <div class="txt01" ref="chatMessages" v-if="index != chatData.length-1 && (isSendFinish && isSendFinish,index != chatData.length-2)">
                        <p v-for="(char, i) in item.pList" :key="i+'k'">{{char}}</p>
                      </div>
                      <div class="txt01" ref="chatMessages" id="messageBody" v-if="index == chatData.length-1 || (isSendFinish && isSendFinish,index == chatData.length-2)">
                        <p v-for="(char, i) in item.pList" :key="i+'k'">
                          <span v-for="(txt, index) in char" :key="index">{{txt}}</span>
                          <span v-if="i == item.pList.length - 1" class="home-main-typed-cursor" :class="{ 'hidden': !isAnimating }">|</span>
                        </p>
                      </div>
                      <!-- <p v-if="sendQuery.chatTaye == '1'" class="txt01" ref="chatMessages">
                          <span v-for="(char, i) in item.messages" :key="i+'b'">{{char}}</span>
                        </p> -->
                      <!-- <p class="txt01" ref="chatMessages" :style="{ height: chatContainerHeight + 'px' }">
                          <span v-for="(char, i) in item.RetContentStr"
                        :class="[{'visible': (currIndex >= i)}, 'chat-char']"
                        :key="i+'b'">{{char}}</span>
                        </p> -->
                      <div class="robot_btn_box">
                        <div>
                          <div class="r_btn01" @click="repeatAnswer(item,index)" v-if="!isNull(item.ContentStr) && index == chatData.length - 1 && !isAnimating && !isSendFinish">
                            <i class="el-icon-refresh r_icon01"></i>
                            <span class="r_txt01">重新回答</span>
                          </div>
                          <div class="r_btn01" @click="stopAnimation" v-if="!isNull(item.ContentStr)&&isAnimating && index == chatData.length - 1">
                            <div class="r_icon02">
                              <p class="r_icon02_line"></p>
                            </div>
                            <span class="r_txt01">停止回答</span>
                          </div>
                        </div>
                        <div class="r_btn02" @click.stop="copy(item.RetContentStr)">
                          <i class="el-icon-document-copy r_icon01"></i>
                        </div>
                      </div>
                      <div class="robot_btn_box01" v-if="!isNull(item.ContentStr)&&isAnimating">
                        <!-- <div class="r_btn01" @click="stopAnimation">
                          <div class="r_icon02">
                            <p class="r_icon02_line"></p>
                          </div>
                          <span class="r_txt01">停止回答</span>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <img src="./../../assets/images/loadgif.gif" v-if="isSendFinish" alt="" style="width:30px;height:30px;"> -->
              </div>
              <!-- 数字人模式 -->
              <!-- <div class="loading videoLoading" v-if="videoLoading">
                <i class="el-icon-loading" style="font-size: 18px;"></i>
                生成中
              </div> -->
              <div class="digital_box" v-if="!isTxtMode">
                <div class="digital_video_box">
                  <!-- <img v-if="!isAudioFinish" src="./../../assets/images/robot.jpeg" alt=""> -->
                  <!--视频播放器 -->
                  <video ref="videoPlayer" :controls="false" oncontextmenu="return false" :muted="true" loop x5-video-player-type="h5-page" style="width:100%;max-height:500px;object-fit: scale-down;" webkit-playsinline="true" playsinline="true" poster="" controlslist="nodownload">
                    <source :src="videoUrl" type="video/mp4">
                    您的浏览器不支持Video标签。
                  </video>
                  <div class="captions">
                    <div class="captionsTxt">{{ captions }}</div>
                  </div>
                  <audio id="music" @ended="audioEnd" v-if="voiceUrl">
                    <source :src="vdopath + voiceUrl" type="audio/mpeg">
                    您的浏览器不支持 audio 元素。
                  </audio>
                </div>
              </div>
            </div>
            <el-select v-model="sendQuery.chatTaye" placeholder="请选择查询内容" size="small" class="sel_box">
              <!-- <el-option label="问岗位" value="2"></el-option> -->
              <el-option label="问其他" value="1"></el-option>
            </el-select>
            <!-- 数字人语音模块 -->
            <div class="c_audio_box" v-if="!isTxtMode">
              <!-- 话筒 -->
              <div class="c_audio_icon" v-if="!isTxtMode&&isNull(intervalId)">
                <i v-if="!isPlay" class="el-icon-microphone" @click="startVisuals" title="开始说话"></i>
                <i v-else class="el-icon-video-pause" @click="pauseVideo" title="停止播放"></i>
              </div>
              <!-- 音量 -->
              <div class="c_audio_jump" v-if="!isTxtMode&&!isNull(intervalId)">
                <!-- <div class="audio-visuals">
                  <div id="bar1" class="bar"></div>
                  <div id="bar2" class="bar"></div>
                  <div id="bar3" class="bar"></div>
                  <div id="bar4" class="bar"></div>
                  <div id="bar5" class="bar"></div>
                  <div id="bar6" class="bar"></div>
                  <div id="bar7" class="bar"></div>
                  <div id="bar8" class="bar"></div>
                  <div id="bar9" class="bar"></div>
                  <div id="bar10" class="bar"></div>
                  <div id="bar11" class="bar"></div>
                  <div id="bar12" class="bar"></div>
                </div> -->
                <div class="prompt-loader">
                  <div class="em" v-for="(item,index) in 15" :key="index"></div>
                </div>
                <div class="r_btn01">
                  <div class="r_icon02" @click="pauseVisuals">
                    <p class="r_icon02_line"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文本发送模块 -->
    <div class="c_send_box flex" v-if="isTxtMode">
      <!-- @keyup.enter.native="sendHandle" -->
      <div class="c_send_input">
        <!-- .trim -->
        <el-input ref="ask" :autosize="{ minRows: 2,maxRows: 6}" clearable type="textarea" @keydown.native="keyDownHandle" placeholder="请输入问题" v-model="sendQuery.msg">
        </el-input>
      </div>
      <div class="c_send_btn">
        <!-- <el-button size="mini" type="success" @click="sendHandle" :disabled="isSendFinish">发送</el-button> -->
        <div class="btnBox" @click="sendHandle">
          <span>发 送</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
import Recorder from "js-audio-recorder";
const lamejs = require("lamejs");
const recorder = new Recorder({
  sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
  sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
  numChannels: 1, // 声道，支持 1 或 2， 默认是1
  // compiling: false,(0.x版本中生效,1.x增加中) // 是否边录边转换，默认是false
});
// 绑定事件-打印的是当前录音数据
recorder.onprogress = function (params) {
  // console.log('--------------START---------------')
  // console.log('录音时长(秒)', params.duration);
  // console.log('录音大小(字节)', params.fileSize);
  // console.log('录音音量百分比(%)', params.vol);
  // console.log('当前录音的总数据([DataView, DataView...])', params.data);
  // console.log('--------------END---------------')
};
import moment from "moment";
export default {
  name: "serviceCenter",
  data() {
    return {
      loginName: "", //登录人名称
      videoLoading: false, //视频加载
      vdopath: this.$store.state.EMP.vdoPath,
      // 发送聊天参数
      sendQuery: {
        titleId: "",
        msg: "",
        isReladSend: "0", //0 不是重复发送 1 重复发送
        isVoice: "0",
        chatTaye: "1", //2 问岗位 1 其他
        fileUrl: "",
      },
      sendVoiceQuery: {
        titleId: "",
        msg: "",
        isReladSend: "0", //0 不是重复发送 1 重复发送
        isVoice: "1",
        chatTaye: "1", //2 问岗位 1 其他
        userid:Cookies.get("userid-b"),
        encoding:"raw"
      },
      isTxtMode: true, //是否是文本模式
      intervalId: null, //定时器id
      chatQuery: {
        Id: "",
        pageNum: 1,
        pageSize: 10000,
      },
      chatData: [],
      docPath: this.$store.state.EMP.docPath,
      isPlay: false, //播放状态
      isIn: false, //鼠标是否位于播放器内
      videoUrl: "",
      voiceUrl: "",
      captions: "", //字幕
      message: "",
      // 标题参数
      titleQuery: {
        titelname: "",
        IsVoice: "0",
        pageNum: 1,
        pageSize: 10000,
      },
      titleData: [], //历史记录聊天数据
      residueNum: 0, //剩余对话次数
      // 文字显示定时
      currIndex: -1,
      timerId: null,
      isAnimating: false,
      message: [],
      isSendFinish: false, //是否返回发送的内容--文本模式
      isAudioFinish: false, //是否返回发送的内容--数字人模式
      defaultMessages: ["你好，很高兴见到你。有什么我可以帮助你的吗?"],
      // 删除参数
      dltQuery: {
        Id: "",
      },
    };
  },
  created() {
    this.videoUrl =
      this.docPath + "85ad7fff2f7b4901845a2a3434afc244/20230526100826601.mp4";
    this.$store.commit("setHiddenTop", true);
    this.$store.commit("setHiddenLeft", true);
    this.loginName = localStorage.userName;
    this.getChatList();
    this.getResidueNum();
    this.getTitleList();
  },
  watch: {
    // chatData() {
    //   if (this.isAnimating) {
    //     // 检查是否处于动画状态
    //     this.$nextTick(() => {
    //       this.startAnimation();
    //     });
    //   } else {
    //     // 去除逐字显示效果，直接展示完整字符串
    //     this.currIndex =
    //       this.chatData[this.chatData.length - 1].RetContentStr.length - 1;
    //     console.log("ff", this.currIndex);
    //   }
    // },
  },
  computed: {
    chatContainerHeight() {
      // 动态计算聊天窗口高度
      this.$nextTick(() => {
        const topOffset = this.$refs.chatMessages.offsetTop;
        const bottomOffset =
          this.$el.offsetHeight - this.$refs.chatMessages.offsetHeight;
        return window.innerHeight - topOffset - bottomOffset - 100; // 减去表单高度和一些额外空间
      });
    },
  },
  methods: {
    // 切换模式
    transHandle() {
      this.isTxtMode = !this.isTxtMode;
      this.titleQuery.IsVoice = this.isTxtMode ? "0" : "1";
      this.getTitleList();
    },
    // 发送文本
    sendHandle() {
      if (this.isSendFinish) return;
      if (this.sendQuery.msg == "") return;
      this.moveBottom();
      this.$nextTick(() => {
        this.$refs[`ask`]._props.value = "";
      });
      setTimeout(() => {
        this.sendQuery.isReladSend = "0";
        this.generateResponse(this.sendQuery, "");
      }, 1000); // 模拟机器人回复时间
    },
    //聊天界面移动到最底部
    moveBottom() {
      let chatHistory = document.getElementsByClassName("chat_main_box")[0];
      this.$nextTick(() => {
        chatHistory.scrollTop = chatHistory.scrollHeight;
      });
    },
    generateResponse(data, isReAnswer) {
      this.isSendFinish = true;
      let info = {
        ContentStr: this.sendQuery.msg,
        RetContentStr: "",
        messages: "",
        pList: [[]],
      };
      this.moveBottom();
      isReAnswer == "isReAnswer"
        ? (this.chatData[this.chatData.length - 1].pList = info)
        : this.chatData.push(info);
      this.$nextTick(() => {
        this.$refs[`ask`]._props.value = "";
      });
      xz.sendchatmsg(data).then((res) => {
        if (res.status == "ok") {
          this.chatQuery.Id = res.data.titleId;
          this.sendQuery.titleId = res.data.titleId;
          this.chatData = res.data.ChatList;
          if (!this.isNull(this.chatData)) {
            for (let index = 0; index < this.chatData.length; index++) {
              let elements = this.chatData[index];
              if (!this.isNull(elements.RetContentStr.indexOf("\n"))) {
                this.$set(
                  elements,
                  "pList",
                  elements.RetContentStr.split("\n")
                );
              }
              this.$set(elements, "messages", elements.RetContentStr.split(""));
            }
          }
          this.isSendFinish = false;
          this.sendQuery.msg = "";
          console.log("chatQuery", this.chatData);
          this.chatData[this.chatData.length - 1].pList = [[]];
          this.startAnimation();
          // this.getChatList()//获取聊天列表
          this.getResidueNum(); //剩余次数
          this.getTitleList(); //历史聊天标题
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    startAnimation() {
      this.isAnimating = true;
      let i = 0;
      let index = 0;
      let lastIndex = this.chatData.length - 1;
      let messages = this.chatData[lastIndex].messages;
      this.timerId = setInterval(() => {
        let a = messages[index];
        if (index + 1 == messages.length) {
          this.stopAnimation();
        } else {
          if (a != "\n") {
            this.chatData[lastIndex].pList[i].push(a);
            this.moveBottom();
          } else {
            i++;
            this.chatData[lastIndex].pList.push([]);
          }
          index++;
        }
      }, 30);
    },
    // 新建对话
    newChat() {
      this.sendQuery.titleId = "";
      this.chatQuery.Id = "";
      this.chatData = [];
      for (let i = 0; i < this.titleData.length; i++) {
        let element = this.titleData[i];
        element.isSelected = false;
      }
    },
    // 点击历史标题查询历史聊天记录
    searchHandle(item, index) {
      // console.log('item', item)
      // this.$set(item,'isSelected',!item.isSelected)
      this.chatQuery.Id = item.Id;
      this.getChatList();
      for (let i = 0; i < this.titleData.length; i++) {
        let element = this.titleData[i];
        if (index == i) {
          element.isSelected = !element.isFlag;
        } else {
          element.isSelected = false;
        }
      }
    },
    // 重新回答
    repeatAnswer(item, index) {
      // console.log('item', item)
      this.chatData[this.chatData.length - 1].pList = [[]];
      let data = {
        titleId: this.sendQuery.titleId,
        msg: item.ContentStr,
        isReladSend: "1",
        chatTaye: this.sendQuery.chatTaye,
        fileUrl: "",
        isVoice: "0",
      };
      this.generateResponse(data, "isReAnswer");
    },
    // 开始动画效果
    startAnimation2() {
      clearInterval(this.timerId);
      this.currIndex = -1;
      if (!this.isNull(this.chatData)) {
        let lengthLast = this.chatData.length - 1;
        let lastData = this.chatData[lengthLast];
        let messData = [];
        // if(this.isNull(this.chatData[lengthLast])){
        // messData = []
        // }else{
        //   messData = lastData.messages;
        // }
        const message = this.chatData[lengthLast].RetContentStr;
        this.timerId = setInterval(() => {
          this.currIndex++;
          // if (this.currIndex >= message.length) {
          //   clearInterval(this.timerId);
          //   this.isAnimating = false; // 移除动画效果
          // }
          // if (message.length === messData.join('').length)
          if (
            message.length == this.chatData[lengthLast].messages.join("").length
          ) {
            clearInterval(this.timerId); // 停止计时器，生成完毕。
            this.isAnimating = false;
          } else {
            const newChar = message.charAt(messData.join("").length);
            // messData.push(newChar)
            this.chatData[lengthLast].messages.push(newChar);
            // console.log(2222,messData,newChar)
          }
        }, 100);
      }
    },
    // 暂停动画效果
    stopAnimation() {
      clearInterval(this.timerId);
      // this.messages = []
      this.isAnimating = false;
    },
    // 删除聊天记录
    dltChat(item) {
      this.dltQuery.Id = item.Id;
      this.$confirm("此操作将删除此对话，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          xz.delchat(this.dltQuery.Id).then((res) => {
            console.log("delchat", res);
            if (res.status == "ok") {
              this.$message({ type: "success", message: "删除成功" });
              this.chatQuery.Id = item.Id;
              this.getChatList();
              this.getTitleList();
            } else {
              this.$message({ type: "error", message: "删除失败,请稍后再试" });
            }
          });
        })
        .catch(() => {});
    },
    // 回车
    keyDownHandle(e) {
      // const e = window.event || arguments[0]
      // if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
      //   e.returnValue = false
      //   return false
      // }
      if (e.keyCode === 13) {
        e.preventDefault(); // 阻止浏览器默认换行操作
        this.sendHandle(); // 发送文本
      }
      // console.log('e',e)
      return false;
    },
    // 获取聊天列表
    getChatList() {
      xz.getchatlist(this.chatQuery).then((res) => {
        // console.log('chatQuery', res)
        if (res.status == "ok") {
          this.chatData = res.data.retList;
          if (!this.isNull(res.data.retList)) {
            for (let index = 0; index < this.chatData.length; index++) {
              let elements = this.chatData[index];
              if (!this.isNull(elements.RetContentStr.indexOf("\n"))) {
                this.$set(
                  elements,
                  "pList",
                  elements.RetContentStr.split("\n")
                );
              }
              this.$set(elements, "messages", elements.RetContentStr.split(""));
            }
            this.sendQuery.titleId = res.data.retList[0].ChatTitleId;
          }
          // console.log('chatQuery', this.chatData)
          // setTimeout(() => {
          //   this.scrollToBottom();
          // }, 0);
        } else {
          this.chatData = [];
        }
      });
    },
    // 获取历史记录聊天标题
    getTitleList() {
      this.titleData = [];
      xz.getchattitel(this.titleQuery).then((res) => {
        // console.log('getList', res)
        if (res.status == "ok") {
          this.titleData = res.data.retList;
        } else {
          this.titleData = [];
        }
      });
    },
    // 获取剩余次数
    getResidueNum() {
      xz.getrestnumconversations("").then((res) => {
        // console.log('num', res)
        if (res.status == "ok") {
          this.residueNum = res.data;
        } else {
          this.residueNum = 0;
        }
      });
    },
    // 复制操作
    copy(context) {
      navigator.clipboard
        .writeText(context)
        .then(() => {
          this.$message.success("复制成功");
        })
        .catch((err) => {
          this.$message.error("复制失败");
        });
    },
    // 模拟音量跳动效果
    startVisuals() {
      if (!this.videoLoading) {
        this.voiceUrl = "";
        recorder.start().then(
          () => {},
          (error) => {
            // 出错了
            console.log(`${error.name} : ${error.message}`);
          }
        );
        // 每隔50毫秒更新一次类音量跳动效果
        if (this.intervalId === null) {
          this.intervalId = setInterval(this.updateVisuals, 200);
        }
        this.$nextTick(() => {
          this.$refs.videoPlayer.pause();
        });
      } else {
        this.$message.warning("正在生成中");
      }
    },
    updateVisuals() {
      // 获取所有条形的DOM元素
      let bars = document.querySelectorAll(".bar");
      // 遍历所有条形并为它们设置随机高度
      for (let i = 0; i < bars.length; i++) {
        let barHeight = Math.floor(Math.random() * 30) + 1;
        bars[i].style.height = barHeight + "px";
      }
    },
    pauseVisuals() {
      clearInterval(this.intervalId); // 停止定时器
      this.isAudioFinish = true;
      this.intervalId = null;
      //结束录音
      recorder.stop();
      let wav = recorder.getPCMBlob(); //获取 WAV 数据
      let audioFile = new File([wav], "voice.pcm", { type: "audio/pcm" });
      console.log(audioFile);
      // let formData = new FormData();
      // formData.append("action", "save");
      // formData.append("pagename", "video");
      // formData.append("userid", Cookies.get("userid-b"));
      // formData.append("entid", Cookies.get("userid-b"));
      // formData.append(
      //   "entPicFile",
      //   audioFile,
      //   new Date().valueOf().toString() + ".pcm"
      // );
      // this.videoLoading = true;
      // xz.uploadCert(formData).then((res) => {
      //   if (res) {
      //     this.sendVoiceQuery.fileUrl = res;
      //     this.generateResponseVoice();
      //     this.destroyRecorder();
      //   } else {
      //     this.$message("系统出错");
      //     this.videoLoading = false;
      //   }
      // });
      this.sendVoiceQuery.chatTaye = this.sendQuery.chatTaye;
      let formData = new FormData();
      formData.append("parm", JSON.stringify(this.sendVoiceQuery));
      formData.append("file",audioFile);
      this.videoLoading = true;
      xz.uploadVoice(formData).then((res) => {
        if (res.status == 'ok') {
          this.destroyRecorder();
          this.sendVoiceQuery.titleId = res.data.titleId;
          this.videoLoading = false;
          this.voiceUrl =
            res.data.ChatList[res.data.ChatList.length - 1].ReplyUrl;
          this.message =
            res.data.ChatList[res.data.ChatList.length - 1].RetContentStr;
          this.$nextTick(() => {
            this.isPlay = true;
            this.$refs.videoPlayer.play();
            let music = document.getElementById("music");
            music.play();
            this.showCaptions();
          });
        } else {
          this.videoLoading = false;
          this.$message.error("生成失败");
        }
      });
    },
    // 销毁录音
    destroyRecorder() {
      recorder.destroy().then(function () {
        recorder = null;
      });
    },
    generateResponseVoice() {
      this.sendVoiceQuery.chatTaye = this.sendQuery.chatTaye;
      xz.sendchatmsg(this.sendVoiceQuery).then((res) => {
        if (res.status == "ok") {
          this.sendVoiceQuery.titleId = res.data.titleId;
          this.videoLoading = false;
          this.voiceUrl =
            res.data.ChatList[res.data.ChatList.length - 1].ReplyUrl;
          this.message =
            res.data.ChatList[res.data.ChatList.length - 1].RetContentStr;
          this.$nextTick(() => {
            this.isPlay = true;
            this.$refs.videoPlayer.play();
            let music = document.getElementById("music");
            music.play();
            this.showCaptions();
          });
        } else {
          this.videoLoading = false;
          this.$message.error("生成失败");
        }
      });
    },
    //字幕显示
    showCaptions() {
      let pList = this.message.replace(/--------------------------/g,'').split("\n");
      console.log(pList)
      if (pList.length > 1) {
        this.captions = pList[0];
        let num = 0;
        let index = 0;
        this.timerId = setInterval(() => {
          num++;
          if (pList[index] == '' || num + 1 == pList[index].length) {
            num = 0;
            index++;
            this.captions = pList[index];
          }
        }, 300);
      }else{
        this.captions = this.message;
      }
    },
    audioEnd() {
      this.$nextTick(() => {
        this.$refs.videoPlayer.pause();
        this.isPlay = false;
        clearInterval(this.timerId);
        this.captions = '';
      });
    },
    pauseVideo() {
      var audio = document.getElementById("music");
      audio.pause();
      this.destroyRecorder();
      this.$nextTick(() => {
        this.$refs.videoPlayer.pause();
        clearInterval(this.timerId);
        this.captions = '';
        this.isPlay = false;
      });
    },
    isNull(o) {
      // console.log('isnull',o)
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == "NaN"
      );
    },
  },
  beforeDestroy() {
    clearInterval(this.timerId); // 在组件销毁前停止计时器以避免内存泄漏。
    clearInterval(this.intervalId);
  },
};
</script>
<style>
.p_chat_content .el-textarea__inner {
  resize: none;
  border: none;
  padding: 5px 10px 5px 13px;
  /* overflow: hidden; */
}
</style>
<style scoped lang="less">
/* .chat-char {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.chat-char.visible {
  opacity: 1;
} */
.c_send_input {
  width: calc(100% - 125px);
}
.p_chat_content {
  -ms-overflow-style: none; /* IE 和 Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    /* Chrome、Safari 和 Opera */
    display: none;
  }
}
.audio-visuals .bar:nth-child(2n-1) {
  height: 15px;
}
.c_audio_jump {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 15px 0;
}
.c_audio_jump .r_icon02 {
  width: 40px;
  height: 40px;
}
.c_audio_jump .r_icon02_line {
  width: 10px;
  height: 10px;
}
.audio-visuals {
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 120px;
  height: 30px;
  margin-right: 20px;
  box-sizing: border-box;
}
.bar {
  background-color: #19bd92;
  height: 30px;
  width: 2px;
}
.digital_video_box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.digital_video_box img {
  height: 260px;
}
.p_chat_content {
  position: relative;
  // height: calc(100% - 51px);
  height: 100%;
  background-color: #fff;
  margin: 0 15px;
  overflow: hidden;
}
.chat_content {
  display: flex;
  margin-top: 10px;
  height: calc(100vh - 100px);
}
.chat_robot_box {
  display: flex;
  margin-bottom: 40px;
}
.robot_btn_box {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 10px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sel_box {
  margin-top: 13px;
}
.robot_btn_box01 {
  position: absolute;
  left: 0;
  bottom: -28px;
  padding: 0 15px;
}
.p_chat_content .r_btn01 {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.p_chat_content .main-con {
  background-color: #fff;
}
.r_icon02 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #797979;
}
.r_icon02_line {
  width: 6px;
  height: 6px;
  border: 1px solid #fff;
}
.robot_btn_box .r_btn02 {
  cursor: pointer;
}
.robot_btn_box .r_txt01,
.robot_btn_box01 .r_txt01 {
  color: #8b8989;
  font-size: 13px;
  margin-left: 3px;
}
.robot_btn_box .r_icon01 {
  color: #777474;
  font-size: 18px;
}
.robot_txt {
  width: 100%;
  position: relative;
  padding: 6px 15px 50px;
  border-radius: 3px;
  // background-color: #f2f2f2;
  background: #f0f9eb;
  border-color: #c2e7b0;
  // background: #d2f1e9;
  box-sizing: border-box;
}
.robot_txt .txt01 {
  font-size: 14px;
  color: #666;
}
.one_img_box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  // background-color: #ddd;
}
.one_img_box img {
  max-width: 30px;
  max-height: 30px;
}
.chat_self_box {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}
.chat_self_icon {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
  background-color: #ccc;
  margin-left: 10px;
}
.chat_self_icon i {
  font-size: 16px;
  color: #fff;
}
.chat_self_txt {
  // flex: 1;
  font-size: 14px;
  color: #000;
  padding: 6px 15px;
  text-align: right;
  background: #f3f3f3;
  line-height: 20px;
  border-radius: 3px;
}
.chat_main_box {
  height: calc(100vh - 290px);
  overflow-y: auto;
  padding: 10px 20px;
  // border: 1px solid #797979;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: rgba(179, 178, 255, 0.3) 0px 4px 16px 0px;
}
.chat_right_content {
  flex: 1;
}
.c_send_box {
  position: absolute;
  right: 0;
  bottom: 10px;
  margin-top: 3px;
  width: calc(100% - 295px);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // padding: 5px 0;
  padding: 12px 5px 30px 15px;
  margin-right: 25px;
  border-radius: 4px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  z-index: 100;
  background-color: #fff;
  box-shadow: rgba(179, 178, 255, 0.3) 0px 4px 16px 0px;
}
.c_audio_icon i {
  font-size: 60px;
  color: #666;
  cursor: pointer;
  transition: all 0.4s; //设置动画时间
}

.c_audio_icon:hover {
  // box-shadow: 0 8px 8px 0 grey;  // 设置盒子阴影
  // transform: translate(0, -10px); // 鼠标悬浮时box向上浮动的距离
  transform: scale(1.1, 1.1);
}
.c_audio_box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 0;
  border: 1px solid #797979;
}

.h_list {
  width: 240px;
  margin-top: 15px;
  // height: calc(100vh - 340px);
  overflow-y: auto;
  padding-bottom: 20px;
}
.h_list_li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 10px;
  padding-left: 10px;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #000c3f;
  font-family: PingFangSC-Regular;
}
.h_list_li span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.h_list_li .h_dlt_icon {
  display: none;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  margin-right: 10px;
}
.h_list_li:hover {
  // color: #19bd92;
  // text-decoration: underline;
  background: #fff;
  border-radius: 5px;
}
// .h_list_li .curr {
//   color: #19bd92;
//   text-decoration: underline;
// }
.h_list_li:hover .h_dlt_icon {
  display: block;
}
// .h_list_li p {
//   width: 180px;
//   height: 16px;
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
//   font-size: 13px;
//   cursor: pointer;
//   color: #000;
// }
.chat_history {
  width: 240px;
  margin-right: 15px;
  background: radial-gradient(
      circle at 100% 0,
      #efe8eb 0,
      rgba(239, 232, 235, 0) 33%
    ),
    radial-gradient(circle at 100% 25%, #e8ebea 0, hsla(160, 7%, 92%, 0) 39%),
    radial-gradient(
      circle at 100% 36%,
      hsla(160, 7%, 92%, 0.6) 0,
      hsla(160, 7%, 92%, 0) 38%
    ),
    linear-gradient(180deg, #efeaef, #dcdcf5 99%);
  background-size: cover;
  overflow-y: auto;
}
.p_chat_box {
  padding: 10px 10px 40px 0px;
  background-color: #fff;
}
.chat_btn_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chat_btn_box .btn02 {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 15px;
}
.chat_btn_box .btn02.btn03 {
  justify-content: flex-end;
}
.chat_btn_box .btn02 .txt02 {
  font-size: 14px;
  color: #333;
}
.chat_btn_box .btn01 {
  width: 240px;
  height: 34px;
  line-height: 34px;
  cursor: pointer;
  text-align: center;
  /* border: 1px solid #666; */
  background-color: #19bd92;
  color: #fff;
  font-size: 14px;
  border-radius: 3px;
}
.chat_title_box {
  height: 52px;
  padding: 5px 10px;
  box-sizing: border-box;
  background-color: rgb(84, 92, 100);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
}
.chat_title_box .txt03 {
  line-height: 30px;
  font-size: 16px;
  color: #fff;
}
.chat_title_right {
  display: flex;
  align-items: center;
}
.chat_title_icon {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
  background-color: #ccc;
  margin-right: 5px;
}
.chat_title_icon i {
  font-size: 16px;
  color: #fff;
}
.chat_title_right .chat_txt {
  font-size: 14px;
  color: #fff;
}
.chat_title_right .txt02 {
  margin-top: 5px;
}
.c_send_btn {
  display: flex;
  justify-content: flex-end;
  // margin-top: 10px;
  padding: 0 20px 0 0;
  height: 38px;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.btnBox {
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: block;
  line-height: 38px;
  width: 100px;
  letter-spacing: 2px;
  font-size: 16px;
  background: #19bd92;
  border-radius: 4px;
}

.btnBox {
  border: 0 solid;
  box-shadow: inset 0 0 20px rgba(255, 255, 255, 0);
  outline: 1px solid;
  outline-color: #19bd92;
  outline-offset: 0px;
  text-shadow: none;
  -webkit-transition: all 1250ms cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 1250ms cubic-bezier(0.19, 1, 0.22, 1);
}
.btnBox:after {
  background: #fff;
  content: "";
  height: 155px;
  left: -75px;
  opacity: 0.2;
  position: absolute;
  top: -50px;
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  transform: rotate(35deg);
  -webkit-transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
  width: 50px;
  z-index: -10;
}

.btnBox:hover:after {
  left: 120%;
  -webkit-transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
}

.btnBox:hover {
  border: 1px solid;
  box-shadow: inset 0 0 20px rgba(255, 255, 255, 0.5),
    0 0 20px rgba(255, 255, 255, 0.2);
  outline-color: rgba(255, 255, 255, 0);
  outline-offset: 15px;
  text-shadow: 1px 1px 2px #427388;
}
.loading {
  font-size: 16px;
}
.home-main-typed-cursor {
  margin-left: 4px;
  font-size: 18px;
}
.home-main-typed-cursor {
  margin-left: 4px;
  font-size: 18px;
}
.is-typed-cursor-anmation {
  animation: typed 0.5s ease infinite alternate;
}
.hidden {
  display: none;
}
.videoLoading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prompt-loader .em {
}
/* 语音音阶------------- */
.prompt-loader {
  width: 170px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 20px;
}
.prompt-loader .em {
  background-color: #67c23a;
  display: block;
  width: 7px;
  height: 40px;
  margin-right: 2.5px;
  float: left;
  border-radius: 5px;
}
.prompt-loader .em:last-child {
  margin-right: 0px;
}
.em:nth-child(1),
.em:nth-child(15) {
  animation: tiao 0.5s 2s infinite linear alternate;
}
.em:nth-child(2),
.em:nth-child(14) {
  animation: tiao 0.5s 1.8s infinite linear alternate;
}
.em:nth-child(3),
.em:nth-child(13) {
  animation: tiao 0.5s 1.6s infinite linear alternate;
}
.em:nth-child(4),
.em:nth-child(12) {
  animation: tiao 0.5s 1.4s infinite linear alternate;
}
.em:nth-child(5),
.em:nth-child(11) {
  animation: tiao 0.5s 1.2s infinite linear alternate;
}
.em:nth-child(6),
.em:nth-child(10) {
  animation: tiao 0.5s 1s infinite linear alternate;
}
.em:nth-child(7),
.em:nth-child(9) {
  animation: tiao 0.5s 0.8s infinite linear alternate;
}
.em:nth-child(8) {
  animation: tiao 0.5s 0.4s infinite linear alternate;
}
@keyframes tiao {
  0% {
    transform: scale(1, 1);
    // background-color: #67c23a;
  }
  100% {
    transform: scale(1, 0.2);
    // background-color: #f56c6c;
  }
}

.isVoice {
  max-width: 1200px;
  margin: 0 auto;
}
.captions {
  position: absolute;
  bottom: 10px;
  width: 100%;
  font-size: 28px;
  color: #fff;
}
.captionsTxt {
  width: 70%;
  text-align: center;
  margin: 0 auto;
}
</style>
